<template>
	<div class="progressbar">
		<div class="progressbar-inner" :style="{width: width}"></div>
	</div>
</template>

<script>

export default {
	name: "progressbar",
	props: {
		min: {
			type: Number,
			default: 0,
		},
		max: {
			type: Number,
			default: 1,
		},
		value: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		width: function () {
			return (Math.max(0, Math.min(1, (this.value / (this.max - this.min)))) * 100).toFixed() + "%";
		},
	},
	data() {
		return {};
	},
	methods: {},
};
</script>

<style scoped>

.progressbar {
	box-shadow: 0 2px 3px #00000040 inset;
	border-radius: 25px;
}

.progressbar-inner {
	margin: 0 auto;
	transition: all .5s ease-out;
	height: 25px;
	background-color: var(--color-validation);
	background-image: linear-gradient(-45deg, #00000020 33%, #FFFFFF20 33%, #FFFFFF20 66%, #00000020 66%),
	linear-gradient(#FFFFFF40, #00000040);
	border-radius: 25px;
	background-size: 50px 100%, 100% 100%, 100% 100%;
	animation: stripes 3s linear infinite;
}

@keyframes stripes {
	100% {
		background-position: -100px 0;
	}
}
</style>
